import Api from "../api/Api";


const client = new Api();

export default function useApi() {
  return client;
}
